import React, { Component } from 'react';
import axios from "axios/dist/axios.min.js";
import utils from "../../utils/utils";
import './style.less';

class PipelinegoodsHorizontal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: []
    };
  }

  componentDidMount() {
    this.getgoodsHorizontalList();
  }

  getgoodsHorizontalList() {
    const itemList = this.props.config.itemList;
    const idList = itemList.map((item) => {
      return isNaN(Number(item.id)) ? 0 : Number(item.id);
    });

    let reqUrl = "";
    if (this.props.config.baseConfig.productType === "商品id") {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/goods/info?access_token=znSnA7pxO35wtPBaur";
    } else {
      reqUrl =
        "https://sh-gateway.shihuo.cn/v4/services/sh-specialapi/style/info?access_token=znSnA7pxO35wtPBaur";
    }

    axios({
      url: reqUrl,
      method: "post",
      withCredentials: true,
      data: {
        ids: idList,
        sort_tag: this.props.config.baseConfig.sortType === '销量' ? 4 : 0,
        filter_subsidy: this.props.config.baseConfig.shihuoSubsidy === '是' ? 1 : 0,
        from: this.props.specialApiFrom
      },
    }).then((res) => {
      if (res.data.status === 0) {
        const list = res.data.data.List;
        // 插入定制化内容
        list.forEach((product) => {
          const customItem = itemList.find((item) => item.id == product.id);
          if (customItem) {
            product.custom_title = customItem.name;
            product.custom_recommend = customItem.recommend;
          }
        });
        this.setState({
          list,
        });
      }
    });
  }

  // 更多跳转
  handleMoreClick = (url) => {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: url,
        props: this.props,
      })
      return
    }
    const options = {};
    utils.jumpToUrl(this.props.routeParams,url,url,options,-1,this.props,false,{blockName: 'more'});
  }

  handleItemClick(item, index) {
    if (this.props.templateName === 'toufang') {
      utils.handleToufangClick({
        link: item.url,
        props: this.props,
        index
      })
      return
    }
    const baseConfig = this.props.config.baseConfig;
    const options = { 
      title: 6,
      type: baseConfig.productStyle,
      sort: index,
      name: item.title
    };
    if (baseConfig.productType === "商品id") {
      options.goods_id = item.id;
    } else {
      options.style_id = item.id;
    }
    console.log(this.props);
    utils.jumpToUrl(this.props.routeParams,item.url,item.url,options,-1,this.props);
  }

  render() {
    const { list } = this.state;
    const { componentDivideLine } = this.props
    const {
        titleBg
      , titleBgColor  
      , titleImage  
      , goodsBodyBg
      , arrowIcon
      , arrowIcon2
      , txtColor
      , moreTxtBg
      , moreTxtBgColor
      , priceTxtColor
      , comBg
      , comBgColor
      , titlePrefix
      , moreLink
      , goodsIcon
    } = this.props.config.baseConfig
    return (
      <div className="pipeline-goodsHorizontal" style={{ backgroundColor: comBgColor }} {...this.props['customAttributes']}>
        <div className="title-img">
          <img src={utils.formatImgUrl(titleImage, this.props.webpSupport)} />
        </div>
        <div 
          className="goodsHorizontal-body"
          style={
            comBg ? {
              background: `url(${utils.formatImgUrl(comBg, this.props.webpSupport)}) no-repeat`,
              backgroundSize: 'cover'
            }: {}
          }
        >
          <div 
          className="goodsHorizontal-title" 
            style={{ 
              color: txtColor,
              ...(titleBg ? {
                background: `url(${utils.formatImgUrl(titleBg, this.props.webpSupport)})`,
                backgroundSize: 'cover'
              } : {
                backgroundColor: titleBgColor
              } )
            }}
          >
            {titlePrefix}
            {/* <img src="https://static.shihuocdn.cn/admin/files/20210328/e9ab042d5b4c4c015a48601a6e1a713e.png" /> */}
            <img src={utils.formatImgUrl(arrowIcon, this.props.webpSupport)} />
          </div>
          <div 
            className="goodsHorizontal-more" 
            style={{ 
              color: txtColor, 
              ...(
                moreTxtBg ? 
                {
                  background: `url(${utils.formatImgUrl(moreTxtBg, this.props.webpSupport)})`,
                  backgroundSize: 'cover',
                  boxShadow: 'none'
                }: {backgroundColor: moreTxtBgColor}
              )
            }} 
            onClick={this.handleMoreClick.bind(this, moreLink)}
          >
            查看更多
              {/* <img src="https://static.shihuocdn.cn/admin/files/20210328/59dd0e500136985624e6f421a53d31ac.png" /> */}
            <img src={utils.formatImgUrl(arrowIcon2, this.props.webpSupport)} />
          </div>
          <div className="goods-body" style={{ backgroundColor: !comBg ? goodsBodyBg : 'transparent' }}>
            <div className="goods-scroll">
              {
                list.map((item, index) => {
                    return (
                      <div className="goods-item" key={`goods-${index}`} onClick={this.handleItemClick.bind(this, item, index)}>
                        {
                          goodsIcon ? 
                          <div className="goods-icon">
                            <img width="100%" src={utils.formatImgUrl(goodsIcon, this.props.webpSupport)} />
                          </div> : ""
                        }
                        <div className="goods-item-img">
                          <img src={utils.formatImgUrl(item.image, this.props.webpSupport)} />
                        </div>
                        <div className="goods-item-title">{item.title}</div>
                        <div className="goods-item-bottom">
                          <div className="goods-item-originalprice">
                            <span>到手价:</span>
                          </div>
                          <div className="goods-item-price" style={{ color: priceTxtColor }}>
                            <span>¥</span>
                            <span>{parseInt(item.price)}</span>
                          </div>
                        </div>
                      </div>
                    )
                })
              }
            </div>
          </div>
        </div>
        {this.props.notLastItem && componentDivideLine && (
          <img className="component-divide-line" src={utils.formatImgUrl(componentDivideLine, this.props.webpSupport)} />
        )}
      </div>
    );
  }
}

export default PipelinegoodsHorizontal;



// WEBPACK FOOTER //
// ./components/pipeline-goodsHorizontal/index.jsx